import { V3Record } from 'data/helpers/V3Record.js'

export const Postcard = V3Record('postcard', {
  associatedObjectId: null, // int
  associatedObjectType: null, // string
  editedImageUrls: null, // object
  layout: {}, // object
  createdAt: null, // datetime
  updatedAt: null // datetime
})

const _defaultDeserialize = Postcard.deserialize
Postcard.deserialize = (fromRails) => {
  const route = _defaultDeserialize(fromRails)
  return route.set('layout', JSON.parse(route.layout))
}
